export default __webpack_public_path__ + "static/media/Contacts.3ae1972d.svg";